// Фасовка позиции склада: товар учитывается в базовой единице (л/кг/шт), а
// закупается упаковками — «10 упаковок молока по 1 л». packSize = сколько
// базовых единиц в одной упаковке.
//
// Контракт с API: остатки, минимум и себестоимость ВСЕГДА в базовых единицах —
// тех-карты списывают их. Упаковки существуют только в полях ввода, поэтому
// пересчёт живёт здесь, а не в каждой форме.
//
// Подписи строим нейтрально к падежам («10 × упаковка 1 л»), потому что название
// упаковки пишет сам пользователь и склонять его нечем.

export type Packaging = { packLabel?: string | null; packSize?: number | null };

/** Задана ли у позиции пригодная фасовка. */
export function hasPackaging(item: Packaging): item is { packLabel: string; packSize: number } {
  return !!item.packLabel && typeof item.packSize === 'number' && item.packSize > 0;
}

/** Гасим хвосты float после делений: 2.7 / 0.9 = 3.0000000000000004. */
export function roundQty(n: number): number {
  return Math.round(n * 1e6) / 1e6;
}

/** Красивое число без «10.000000». */
export function fmtQty(n: number): string {
  return String(roundQty(n));
}

export const packsToBase = (packs: number, packSize: number) => roundQty(packs * packSize);
export const baseToPacks = (base: number, packSize: number) => roundQty(base / packSize);

/** Короткая форма для тесных мест (кнопка-переключатель): «упаковка» → «упак.». */
export function shortPack(label: string): string {
  const s = label.trim();
  return s.length > 5 ? `${s.slice(0, 4)}.` : s;
}

/** «упаковка = 1 л» — подпись фасовки в таблице/списке. */
export function packagingLabel(item: Packaging & { unit: string }): string | null {
  if (!hasPackaging(item)) return null;
  return `${item.packLabel} = ${fmtQty(item.packSize)} ${item.unit}`;
}

/** «10 × упаковка 1 л = 10 л» — пояснение под полем ввода в упаковках. */
export function packagingMath(packs: number, item: Packaging & { unit: string }): string | null {
  if (!hasPackaging(item)) return null;
  const base = packsToBase(packs, item.packSize);
  return `${fmtQty(packs)} × ${item.packLabel} ${fmtQty(item.packSize)} ${item.unit} = ${fmtQty(base)} ${item.unit}`;
}

/** «≈ 10 × упаковка» — сколько упаковок в остатке. */
export function packagingCount(base: number, item: Packaging): string | null {
  if (!hasPackaging(item)) return null;
  return `${fmtQty(baseToPacks(base, item.packSize))} × ${item.packLabel}`;
}
